// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ly-1";
export var messageSideRight = "_ly-2";
export var orderLookupBubbleContainer = "_ly-0";
export var submitButton = "_ly-3";